import { ContactUsApiResponse } from './interfaces/contact-us-api-response.interface';
import { ContactUsRequestDto } from './interfaces/contact-us-request-dto.interface';

// Attention: URL to production environment
const apiURL =
  process.env.CONTACT_US_AZURE_API_ENDPOINT ||
  process.env.GATSBY_CONTACT_US_AZURE_API_ENDPOINT;

export const postContactUs = async (
  payload: ContactUsRequestDto,
  integrationId: string,
): Promise<ContactUsApiResponse> => {
  if (!apiURL) {
    throw new Error(
      'API endpoint not configured properly, please update environment files',
    );
  }
  const url = new URL(`${apiURL}/send-contact-request`);

  url.searchParams.append('meetingPlaceIntegrationId', integrationId);

  const options: RequestInit = {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: new Headers({
      'Content-type': 'application/json; charset=utf-8',
      'x-functions-key': `${process.env.GATSBY_CONTACT_US_FUNCTION_KEY}`,
    }),
  };

  const response = await fetch(url, options);
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(`Server error ${response.status} - ${response.statusText}`);
  }
};
